import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Classes from '../Classes';
import CallToActionIcon from './CallToActionIcon';
import Utils from '../../common/Utils';

class CallToActionComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  getTheInfoMessage= (isNetworkingShow) => {
    if (this.props.callToActionFailed) {
      return isNetworkingShow ? this.props.callToActionBtnStatusContent.callToActionErrorMessage.infoNetworking : this.props.callToActionBtnStatusContent.callToActionErrorMessage.info;
    } else if (this.props.disabled) {
      return isNetworkingShow ? this.props.callToActionBtnStatusContent.callToActionSuccessMessage.infoNetworking : this.props.callToActionBtnStatusContent.callToActionSuccessMessage.info;
    }
    return isNetworkingShow ? this.props.callToActionBtnStatusContent.callToActionDefaultMessage.infoNetworking : this.props.callToActionBtnStatusContent.callToActionDefaultMessage.info;
  }

  getTheDetailsMessageErrorDiv = () => (
    <div
      className={classnames(Classes.callToActiondetails, Classes.calltoActionDetailsMessageError)}
    >
      { this.props.callToActionBtnStatusContent.callToActionErrorMessage.message }
    </div>)

  getTheDetailsMessageDiv = (isNetworkingShow) => {
    const callToActionSuccessMessage = isNetworkingShow ? this.props.callToActionBtnStatusContent.callToActionSuccessMessage.messageNetworking : this.props.callToActionBtnStatusContent.callToActionSuccessMessage.message;
    const callToActionDefaultMessage = isNetworkingShow ? this.props.callToActionBtnStatusContent.callToActionDefaultMessage.messageNetworking : this.props.callToActionBtnStatusContent.callToActionDefaultMessage.message;
    const message = this.props.disabled ? callToActionSuccessMessage : callToActionDefaultMessage;

    return (
      <div className={classnames(Classes.callToActiondetails, Classes.calltoActionDetailsMessageHighlight)}>
        {message}
      </div>
    )}

  render() {
    const isNetworkingShow = Utils.getFromSessionStorage('isParticipationEvent');
    return (
      <div className={Classes.marginTopAndBottom}>
        { this.props.callToActionFailed && this.getTheDetailsMessageErrorDiv()}
        { !this.props.callToActionFailed && this.getTheDetailsMessageDiv(isNetworkingShow)}
        <div
          className={(Classes.callToActiondetails, Classes.calltoActionDetailsMessageInfo)}
        >{this.getTheInfoMessage(isNetworkingShow)}
        </div>
        <div
          onClick={this.props.handleClick}
          className={classnames(Classes.requestContactButton, Classes.primaryButton)}
          data-dtm={this.props.dataDtm}
          data-dtm-action={this.props.dataDtmAction}
          data-dtm-attributes={JSON.stringify(this.props.dataDtmAttribute)}
          role="button"
          disabled={this.props.disabled || this.props.callToActionFailed}
          tabIndex={0}
        >
          <span className={Classes.ExhibitorDetailIcons}>
            <CallToActionIcon
              disabled={this.props.disabled}
            />
            <span>{this.props.disabled ? this.props.callToActionBtnStatusContent.callToAction.callbackrequested :
              this.props.callToActionBtnStatusContent.callToAction.callbackRequest}
            </span>
          </span>
        </div>
      </div>
    );
  }
}

CallToActionComponent.propTypes = {
  dataDtmAttribute: PropTypes.object.isRequired,
  dataDtm: PropTypes.string.isRequired,
  dataDtmAction: PropTypes.string.isRequired,
  handleClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  callToActionFailed: PropTypes.bool.isRequired,
  callToActionBtnStatusContent: PropTypes.object.isRequired
};

export default CallToActionComponent;
